module.exports = __webpack_public_path__ + "img/about-4.b0a0142c.jpg";